import * as rules from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate'
import Vue from 'vue'

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})

extend('bank_name', {
  validate: value => /^[a-zA-Z؀-ۿ\s.&'-]{2,100}$/.test(value),
  message: 'The {_field_} may only contain letters, spaces and . & \' - (2-100 characters)'
})

extend('bank_address', {
  validate: value => /^[a-zA-Z0-9؀-ۿ\s.,#/()'-]{5,255}$/.test(value),
  message: 'The {_field_} contains invalid characters (5-255 characters)'
})

// SWIFT / BIC: 4 bank + 2 country letters, 2 location chars, optional 3 branch chars
extend('swift', {
  validate: value => /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/.test(value.replace(/\s/g, '').toUpperCase()),
  message: 'The {_field_} must be a valid SWIFT/BIC code (8 or 11 characters)'
})

// Format check + ISO 13616 mod-97 checksum
extend('iban', {
  validate: value => {
    const iban = value.replace(/\s/g, '').toUpperCase()
    if (!/^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/.test(iban)) return false
    const numeric = (iban.slice(4) + iban.slice(0, 4))
      .replace(/[A-Z]/g, ch => ch.charCodeAt(0) - 55)
    return numeric.match(/\d{1,7}/g).reduce((rem, part) => Number(rem + part) % 97, '') === 1
  },
  message: 'The {_field_} is not a valid IBAN'
})

Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)
